import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'
import { queryClient } from './lib/queryClient'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
  })
}

// Tema flash'ını önlemek için React yüklenmeden önce class'ları uygula
;(function initTheme() {
  try {
    const stored = localStorage.getItem('nova-ui')
    const state = stored
      ? (JSON.parse(stored) as { state?: { tema?: string; palet?: string } }).state
      : null
    if (state?.tema === 'dark') document.documentElement.classList.add('dark')
    else document.documentElement.classList.remove('dark')
    document.documentElement.dataset.theme = state?.palet ?? 'modern'
  } catch {
    document.documentElement.classList.remove('dark')
    document.documentElement.dataset.theme = 'modern'
  }
})()

async function enableMocking() {
  // Tauri webview'da veya gerçek API yapılandırıldığında service worker çalışmaz
  if (import.meta.env.PROD || window.__TAURI__) return
  if (import.meta.env.VITE_API_BASE_URL) return
  const { worker } = await import('./services/mock/browser')
  return worker.start({ onUnhandledRequest: 'bypass' })
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>
  )
})
